import React from 'react'
import './menu.scss'

import { Link } from "react-router-dom"

import dashboardIcon from '../../../assets/svg/dashboardIcon.svg'
import peykIcon from '../../../assets/svg/PMotorCycle.svg'
import monitoringIcon from '../../../assets/svg/PMonitoring.svg'
import accountingIcon from '../../../assets/svg/PAccounting.svg'
import orderIcon from '../../../assets/svg/orderIcon.svg'
import messageIcon from '../../../assets/svg/PPeykMessage.svg'
import reqIcon from '../../../assets/svg/PeykReq.svg'
import exitIcon from '../../../assets/svg/exitIcon.svg'

export default function index({ page, badgeCountDashboard, badgeCountOrder }) {
  return (
    <aside id='aside'>
      <Link to='/dashboard' className='column'>
        <div className={page === 'dashboard' ? 'row active' : 'row'}>
          <img src={dashboardIcon} alt='' />
          <span>
            داشبورد اصلی
          </span>
        </div>
      </Link>
      {/* item */}
      <div className='title'>
        پیک
        <hr style={{ width: '74%' }} />
      </div>
      {/* item */}
      <Link to='/peyk' className='column'>
        <div className={page === 'dashboardPeyk' ? 'row active' : 'row'}>
          <img src={dashboardIcon} alt='' />
          <span>
            پیک موتوری
          </span>
        </div>
      </Link>
      {/* title */}
      <div className='title'>
        مدیریت
        <hr style={{ width: '65%' }} />
      </div>
      {/* item */}
      <Link to='/peyk/peyks' className='column'>
        <div className={page === 'peyks' ? 'row active' : 'row'}>
          <img src={peykIcon} alt='' width={'22px'} height={'19px'} />
          <span>
            پیک‌ها
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/peyk/monitoring' className='column'>
        <div className={page === 'monitoring' ? 'row active' : 'row'}>
          <img src={monitoringIcon} alt='' width={'22px'} height={'19px'} />
          <span>
            مانیتورینگ
          </span>
        </div>
      </Link>
      {/* item */}
      <div className='title'>
        حسابداری
        <hr style={{ width: '64%' }} />
      </div>
      {/* item */}
      <Link to='/peyk/accounting' className='column'>
        <div className={page === 'accounting' ? 'row active' : 'row'}>
          <img src={accountingIcon} alt='' width={'22px'} height={'19px'} />
          <span>
            مالی و حسابداری
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/peyk/orders' className='column'>
        <div className={page === 'orders' ? 'row active' : 'row'}>
          <img src={orderIcon} alt='' />
          <span>
            سفارشات
          </span>
        </div>
      </Link>
      {/* item */}
      <div className='title'>
        امکانات
        <hr style={{ width: '64%' }} />
      </div>
      {/* item */}
      <Link to='/peyk/messages' className='column'>
        <div className={page === 'messages' ? 'row active' : 'row'}>
          <img src={messageIcon} alt='' width={'22px'} height={'19px'} />
          <span>
            پیام به پیک
          </span>
        </div>
      </Link>
      {/* title */}
      <Link to='/peyk/jobs' className='column'>
        <div className={page === 'jobs' ? 'row active' : 'row'}>
          <img src={reqIcon} alt='' width={'22px'} height={'19px'} />
          <span>
            رزومه‌ها
          </span>
        </div>
      </Link>
      {/* item */}
      <Link href='##'>
        <div className='support'>
          <span>
            +
          </span>
          <span>
            تماس با پشتیبانی
          </span>
          <span>
            5719 3559 - 041   
          </span>
        </div>
      </Link>
      {/* item */}
      <Link to='/' className='column'>
        <div className={page === 'exit' ? 'row active' : 'row'}>
          <img src={exitIcon} alt='' />
          <span>
            خروج
          </span>
        </div>
      </Link>
    </aside>
  )
}
